import { Capacitor } from '@capacitor/core';

// True inside the SocraQuest iOS/Android app (Capacitor), false on the website.
export function isNativeApp() {
  try {
    return Capacitor.isNativePlatform();
  } catch (e) {
    return false;
  }
}

// Where logged-out users go: the app opens straight on the login page, the website shows the landing page.
export function loggedOutHome() {
  return isNativeApp() ? '/login' : '/welcome';
}
